import { api } from './axios';

/**
 * Mirrors school.api.ts's downloadExport / lms.api.ts's downloadSubmissionFile
 * (blob fetch through the authenticated axios instance + object URL +
 * synthetic anchor) — shared here since student documents, qualification
 * certificates, TC and report-card PDFs all need the exact same mechanism
 * once their raw /uploads links became guarded routes.
 */
export async function downloadAuthFile(path: string, filename: string): Promise<void> {
  const res = await api.get(path, { responseType: 'blob' });
  const blob = new Blob([res.data]);
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}
